import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { HttpClientModule, HttpClient } from '@angular/common/http';
// import { HttpLoaderFactory } from '../../../app.module';
import { FormsModule } from '@angular/forms';
import { RAFormModule } from '../../../ra-form/ra-form.module';
//  import { BoardRoutingModule } from './Board-routing.module';
import { BoardComponent } from './Board.component';
import { HttpLoaderFactory } from 'src/app/http-loader-factory';
@NgModule({
imports: [
CommonModule,
// BoardRoutingModule,
RAFormModule,
FormsModule,
HttpClientModule,
TranslateModule.forChild({
loader: {
provide: TranslateLoader,
useFactory: HttpLoaderFactory, // Moved to Seperate File By Mirsha
deps: [HttpClient]
}
}),
],
declarations: [
BoardComponent,
],
exports:[
BoardComponent,
],
})
export class BoardModule { }
